import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`

:root {
  --white: white;
  --black: black;
  --trasparent: trasparent;
  --border-color: ${({ theme }) => theme['border-color']};
  --primary30: ${({ theme }) => theme.primary30};
  --primary40: ${({ theme }) => theme.primary40};
  --primary50: ${({ theme }) => theme.primary50};
  --primary60: ${({ theme }) => theme.primary60};
  --primary70: ${({ theme }) => theme.primary70};
  --link40: ${({ theme }) => theme.link40};
  --link50: ${({ theme }) => theme.link50};
  --link60: ${({ theme }) => theme.link60};
  --red40: ${({ theme }) => theme.red40};
  --red50: ${({ theme }) => theme.red50};
  --red60: ${({ theme }) => theme.red60};
  --secondary30: ${({ theme }) => theme.secondary30};
  --secondary40: ${({ theme }) => theme.secondary40};
  --secondary50: ${({ theme }) => theme.secondary50};
  --secondary60: ${({ theme }) => theme.secondary60};
  --secondary70: ${({ theme }) => theme.secondary70};
  --danger40: ${({ theme }) => theme.danger40};
  --danger50: ${({ theme }) => theme.danger50};
  --danger60: ${({ theme }) => theme.danger60};
  --dark40: ${({ theme }) => theme.dark40};
  --dark50: ${({ theme }) => theme.dark50};
  --dark60: ${({ theme }) => theme.dark60};
  --success40: ${({ theme }) => theme.success40};
  --success50: ${({ theme }) => theme.success50};
  --success60: ${({ theme }) => theme.success60};
  --blue: ${({ theme }) => theme.blue};
  --green: ${({ theme }) => theme.green};
  --indigo: ${({ theme }) => theme.indigo};
  --orange: ${({ theme }) => theme.orange};
  --pink: ${({ theme }) => theme.pink};
  --purple: ${({ theme }) => theme.purple};
  --red: ${({ theme }) => theme.red};
  --teal: ${({ theme }) => theme.teal};
  --yellow: ${({ theme }) => theme.yellow};
  --gray1: ${({ theme }) => theme.gray1};
  --gray2: ${({ theme }) => theme.gray2};
  --gray3: ${({ theme }) => theme.gray3};
  --gray4: ${({ theme }) => theme.gray4};
  --gray5: ${({ theme }) => theme.gray5};
  --gray6: ${({ theme }) => theme.gray6};

  --primary: ${({ theme }) => theme.primary};
  --primary-focus: ${({ theme }) => theme['primary-focus']};
  --focus: ${({ theme }) => theme.focus};
  --active: ${({ theme }) => theme.active};
  --secondary: ${({ theme }) => theme.secondary};
  --disabled-dark: #3B3B3B;
  --disabled-light: #C4C4C4;

  --gh-text: ${({ theme }) => theme['gh-text']};
  --gh-text-secondary: ${({ theme }) => theme['gh-text-secondary']};
  --gh-border: ${({ theme }) => theme['gh-border']};
  --gh-bg0: ${({ theme }) => theme['gh-bg0']};
  --gh-bg1: ${({ theme }) => theme['gh-bg1']};



  --color-scale-black: #010409;
    --color-scale-white: #f0f6fc;
    --color-scale-gray-0: #f0f6fc;
    --color-scale-gray-1: #c9d1d9;
    --color-scale-gray-2: #b1bac4;
    --color-scale-gray-3: #8b949e;
    --color-scale-gray-4: #6e7681;
    --color-scale-gray-5: #484f58;
    --color-scale-gray-6: #30363d;
    --color-scale-gray-7: #21262d;
    --color-scale-gray-8: #161b22;
    --color-scale-gray-9: #0d1117;
    --color-scale-blue-0: #cae8ff;
    --color-scale-blue-1: #a5d6ff;
    --color-scale-blue-2: #79c0ff;
    --color-scale-blue-3: #58a6ff;
    --color-scale-blue-4: #388bfd;
    --color-scale-blue-5: #1f6feb;
    --color-scale-blue-6: #1158c7;
    --color-scale-blue-7: #0d419d;
    --color-scale-blue-8: #0c2d6b;
    --color-scale-blue-9: #051d4d;
    --color-scale-green-0: #aff5b4;
    --color-scale-green-1: #7ee787;
    --color-scale-green-2: #56d364;
    --color-scale-green-3: #3fb950;
    --color-scale-green-4: #2ea043;
    --color-scale-green-5: #238636;
    --color-scale-green-6: #196c2e;
    --color-scale-green-7: #0f5323;
    --color-scale-green-8: #033a16;
    --color-scale-green-9: #04260f;
    --color-scale-yellow-0: #f8e3a1;
    --color-scale-yellow-1: #f2cc60;
    --color-scale-yellow-2: #e3b341;
    --color-scale-yellow-3: #d29922;
    --color-scale-yellow-4: #bb8009;
    --color-scale-yellow-5: #9e6a03;
    --color-scale-yellow-6: #845306;
    --color-scale-yellow-7: #693e00;
    --color-scale-yellow-8: #4b2900;
    --color-scale-yellow-9: #341a00;
    --color-scale-orange-0: #ffdfb6;
    --color-scale-orange-1: #ffc680;
    --color-scale-orange-2: #ffa657;
    --color-scale-orange-3: #f0883e;
    --color-scale-orange-4: #db6d28;
    --color-scale-orange-5: #bd561d;
    --color-scale-orange-6: #9b4215;
    --color-scale-orange-7: #762d0a;
    --color-scale-orange-8: #5a1e02;
    --color-scale-orange-9: #3d1300;
    --color-scale-red-0: #ffdcd7;
    --color-scale-red-1: #ffc1ba;
    --color-scale-red-2: #ffa198;
    --color-scale-red-3: #ff7b72;
    --color-scale-red-4: #f85149;
    --color-scale-red-5: #da3633;
    --color-scale-red-6: #b62324;
    --color-scale-red-7: #8e1519;
    --color-scale-red-8: #67060c;
    --color-scale-red-9: #490202;
    --color-scale-purple-0: #eddeff;
    --color-scale-purple-1: #e2c5ff;
    --color-scale-purple-2: #d2a8ff;
    --color-scale-purple-3: #bc8cff;
    --color-scale-purple-4: #a371f7;
    --color-scale-purple-5: #8957e5;
    --color-scale-purple-6: #6e40c9;
    --color-scale-purple-7: #553098;
    --color-scale-purple-8: #3c1e70;
    --color-scale-purple-9: #271052;
    --color-scale-pink-0: #ffdaec;
    --color-scale-pink-1: #ffbedd;
    --color-scale-pink-2: #ff9bce;
    --color-scale-pink-3: #f778ba;
    --color-scale-pink-4: #db61a2;
    --color-scale-pink-5: #bf4b8a;
    --color-scale-pink-6: #9e3670;
    --color-scale-pink-7: #7d2457;
    --color-scale-pink-8: #5e103e;
    --color-scale-pink-9: #42062a;
    --color-auto-black: #f0f6fc;
    --color-auto-white: #010409;
    --color-auto-gray-0: #0d1117;
    --color-auto-gray-1: #161b22;
    --color-auto-gray-2: #21262d;
    --color-auto-gray-3: #30363d;
    --color-auto-gray-4: #484f58;
    --color-auto-gray-5: #6e7681;
    --color-auto-gray-6: #8b949e;
    --color-auto-gray-7: #b1bac4;
    --color-auto-gray-8: #c9d1d9;
    --color-auto-gray-9: #f0f6fc;
    --color-auto-blue-0: #051d4d;
    --color-auto-blue-1: #0c2d6b;
    --color-auto-blue-2: #0d419d;
    --color-auto-blue-3: #1158c7;
    --color-auto-blue-4: #1f6feb;
    --color-auto-blue-5: #388bfd;
    --color-auto-blue-6: #58a6ff;
    --color-auto-blue-7: #79c0ff;
    --color-auto-blue-8: #a5d6ff;
    --color-auto-blue-9: #cae8ff;
    --color-auto-green-0: #04260f;
    --color-auto-green-1: #033a16;
    --color-auto-green-2: #0f5323;
    --color-auto-green-3: #196c2e;
    --color-auto-green-4: #238636;
    --color-auto-green-5: #2ea043;
    --color-auto-green-6: #3fb950;
    --color-auto-green-7: #56d364;
    --color-auto-green-8: #7ee787;
    --color-auto-green-9: #aff5b4;
    --color-auto-yellow-0: #341a00;
    --color-auto-yellow-1: #4b2900;
    --color-auto-yellow-2: #693e00;
    --color-auto-yellow-3: #845306;
    --color-auto-yellow-4: #9e6a03;
    --color-auto-yellow-5: #bb8009;
    --color-auto-yellow-6: #d29922;
    --color-auto-yellow-7: #e3b341;
    --color-auto-yellow-8: #f2cc60;
    --color-auto-yellow-9: #f8e3a1;
    --color-auto-orange-0: #3d1300;
    --color-auto-orange-1: #5a1e02;
    --color-auto-orange-2: #762d0a;
    --color-auto-orange-3: #9b4215;
    --color-auto-orange-4: #bd561d;
    --color-auto-orange-5: #db6d28;
    --color-auto-orange-6: #f0883e;
    --color-auto-orange-7: #ffa657;
    --color-auto-orange-8: #ffc680;
    --color-auto-orange-9: #ffdfb6;
    --color-auto-red-0: #490202;
    --color-auto-red-1: #67060c;
    --color-auto-red-2: #8e1519;
    --color-auto-red-3: #b62324;
    --color-auto-red-4: #da3633;
    --color-auto-red-5: #f85149;
    --color-auto-red-6: #ff7b72;
    --color-auto-red-7: #ffa198;
    --color-auto-red-8: #ffc1ba;
    --color-auto-red-9: #ffdcd7;
    --color-auto-purple-0: #271052;
    --color-auto-purple-1: #3c1e70;
    --color-auto-purple-2: #553098;
    --color-auto-purple-3: #6e40c9;
    --color-auto-purple-4: #8957e5;
    --color-auto-purple-5: #a371f7;
    --color-auto-purple-6: #bc8cff;
    --color-auto-purple-7: #d2a8ff;
    --color-auto-purple-8: #e2c5ff;
    --color-auto-purple-9: #eddeff;
    --color-auto-pink-0: #42062a;
    --color-auto-pink-1: #5e103e;
    --color-auto-pink-2: #7d2457;
    --color-auto-pink-3: #9e3670;
    --color-auto-pink-4: #bf4b8a;
    --color-auto-pink-5: #db61a2;
    --color-auto-pink-6: #f778ba;
    --color-auto-pink-7: #ff9bce;
    --color-auto-pink-8: #ffbedd;
    --color-auto-pink-9: #ffdaec;
    --color-text-primary: #c9d1d9;
    --color-text-secondary: #8b949e;
    --color-text-tertiary: #8b949e;
    --color-text-placeholder: #484f58;
    --color-text-disabled: #484f58;
    --color-text-inverse: #0d1117;
    --color-text-link: #58a6ff;
    --color-text-danger: #f85149;
    --color-text-success: #56d364;
    --color-text-warning: #e3b341;
    --color-text-white: #f0f6fc;
    --color-icon-primary: #c9d1d9;
    --color-icon-secondary: #6e7681;
    --color-icon-tertiary: #484f58;
    --color-icon-info: #79c0ff;
    --color-icon-danger: #f85149;
    --color-icon-success: #56d364;
    --color-icon-warning: #e3b341;
    --color-border-primary: #30363d;
    --color-border-secondary: #21262d;
    --color-border-tertiary: #6e7681;
    --color-border-overlay: #30363d;
    --color-border-inverse: #f0f6fc;
    --color-border-info: rgba(56,139,253,0.4);
    --color-border-danger: rgba(248,81,73,0.4);
    --color-border-success: rgba(63,185,80,0.4);
    --color-border-warning: rgba(187,128,9,0.4);
    --color-bg-canvas: #0d1117;
    --color-bg-canvas-mobile: #010409;
    --color-bg-canvas-inverse: #f0f6fc;
    --color-bg-canvas-inset: #090c10;
    --color-bg-primary: #0d1117;
    --color-bg-secondary: #0d1117;
    --color-bg-tertiary: #161b22;
    --color-bg-overlay: #21262d;
    --color-bg-backdrop: rgba(1,4,9,0.8);
    --color-bg-info: rgba(56,139,253,0.1);
    --color-bg-info-inverse: #388bfd;
    --color-bg-danger: rgba(248,81,73,0.1);
    --color-bg-danger-inverse: #da3633;
    --color-bg-success: rgba(46,160,67,0.1);
    --color-bg-success-inverse: #2ea043;
    --color-bg-warning: rgba(187,128,9,0.1);
    --color-bg-warning-inverse: #bb8009;
    --color-shadow-small: 0 0 transparent;
    --color-shadow-medium: 0 3px 6px #010409;
    --color-shadow-large: 0 8px 24px #010409;
    --color-shadow-extra-large: 0 12px 48px #010409;
    --color-shadow-highlight: 0 0 transparent;
    --color-shadow-inset: 0 0 transparent;
    --color-state-hover-primary-bg: #1f6feb;
    --color-state-hover-primary-border: #388bfd;
    --color-state-hover-primary-text: #f0f6fc;
    --color-state-hover-primary-icon: #f0f6fc;
    --color-state-hover-secondary-bg: #161b22;
    --color-state-hover-secondary-border: #161b22;
    --color-state-selected-primary-bg: #1f6feb;
    --color-state-selected-primary-border: #388bfd;
    --color-state-selected-primary-text: #f0f6fc;
    --color-state-selected-primary-icon: #f0f6fc;
    --color-state-focus-border: #388bfd;
    --color-state-focus-shadow: 0 0 0 3px #0c2d6b;
    --color-fade-fg-10: rgba(240,246,252,0.1);
    --color-fade-fg-15: rgba(240,246,252,0.15);
    --color-fade-fg-30: rgba(240,246,252,0.3);
    --color-fade-fg-50: rgba(240,246,252,0.5);
    --color-fade-fg-70: rgba(240,246,252,0.7);
    --color-fade-fg-85: rgba(240,246,252,0.85);
    --color-fade-black-10: rgba(1,4,9,0.1);
    --color-fade-black-15: rgba(1,4,9,0.15);
    --color-fade-black-30: rgba(1,4,9,0.3);
    --color-fade-black-50: rgba(1,4,9,0.5);
    --color-fade-black-70: rgba(1,4,9,0.7);
    --color-fade-black-85: rgba(1,4,9,0.85);
    --color-fade-white-10: rgba(240,246,252,0.1);
    --color-fade-white-15: rgba(240,246,252,0.15);
    --color-fade-white-30: rgba(240,246,252,0.3);
    --color-fade-white-50: rgba(240,246,252,0.5);
    --color-fade-white-70: rgba(240,246,252,0.7);
    --color-fade-white-85: rgba(240,246,252,0.85);
    --color-alert-info-text: #79c0ff;
    --color-alert-info-icon: #79c0ff;
    --color-alert-info-bg: rgba(56,139,253,0.1);
    --color-alert-info-border: rgba(56,139,253,0.4);
    --color-alert-warn-text: #e3b341;
    --color-alert-warn-icon: #e3b341;
    --color-alert-warn-bg: rgba(187,128,9,0.1);
    --color-alert-warn-border: rgba(187,128,9,0.4);
    --color-alert-error-text: #ff7b72;
    --color-alert-error-icon: #ff7b72;
    --color-alert-error-bg: rgba(248,81,73,0.1);
    --color-alert-error-border: rgba(248,81,73,0.4);
    --color-alert-success-text: #56d364;
    --color-alert-success-icon: #56d364;
    --color-alert-success-bg: rgba(46,160,67,0.1);
    --color-alert-success-border: rgba(46,160,67,0.4);
    --color-autocomplete-shadow: 0 16px 32px rgba(1,4,9,0.85);
    --color-autocomplete-row-border: #30363d;
    --color-blankslate-icon: #535c66;
    --color-btn-text: #c9d1d9;
    --color-btn-bg: #21262d;
    --color-btn-border: #30363d;
    --color-btn-shadow: 0 0 transparent;
    --color-btn-inset-shadow: 0 0 transparent;
    --color-btn-hover-bg: #30363d;
    --color-btn-hover-border: #8b949e;
    --color-btn-selected-bg: #161b22;
    --color-btn-focus-bg: #21262d;
    --color-btn-focus-border: #8b949e;
    --color-btn-focus-shadow: 0 0 0 3px rgba(139,148,158,0.3);
    --color-btn-shadow-active: inset 0 0.15em 0.3em rgba(1,4,9,0.15);
    --color-btn-shadow-input-focus: 0 0 0 0.2em rgba(31,111,235,0.3);
    --color-btn-primary-text: #fff;
    --color-btn-primary-bg: #238636;
    --color-btn-primary-border: #2ea043;
    --color-btn-primary-shadow: 0 0 transparent;
    --color-btn-primary-inset-shadow: 0 0 transparent;
    --color-btn-primary-hover-bg: #2ea043;
    --color-btn-primary-hover-border: #3fb950;
    --color-btn-primary-selected-bg: #238636;
    --color-btn-primary-selected-shadow: 0 0 transparent;
    --color-btn-primary-disabled-text: rgba(240,246,252,0.5);
    --color-btn-primary-disabled-bg: rgba(35,134,54,0.6);
    --color-btn-primary-disabled-border: transparent;
    --color-btn-primary-focus-bg: #238636;
    --color-btn-primary-focus-border: #3fb950;
    --color-btn-primary-focus-shadow: 0 0 0 3px rgba(46,164,79,0.4);
    --color-btn-primary-icon: #f0f6fc;
    --color-btn-primary-counter-bg: rgba(240,246,252,0.2);
    --color-btn-outline-text: #58a6ff;
    --color-btn-outline-hover-text: #58a6ff;
    --color-btn-outline-hover-bg: #30363d;
    --color-btn-outline-hover-border: #58a6ff;
    --color-btn-outline-hover-shadow: 0 1px 0 rgba(1,4,9,0.1);
    --color-btn-outline-hover-inset-shadow: inset 0 1px 0 rgba(240,246,252,0.03);
    --color-btn-outline-hover-counter-bg: rgba(240,246,252,0.2);
    --color-btn-outline-selected-text: #f0f6fc;
    --color-btn-outline-selected-bg: #0d419d;
    --color-btn-outline-selected-border: rgba(240,246,252,0.1);
    --color-btn-outline-selected-shadow: 0 0 transparent;
    --color-btn-outline-disabled-text: rgba(88,166,255,0.5);
    --color-btn-outline-disabled-bg: #0d1117;
    --color-btn-outline-disabled-counter-bg: rgba(31,111,235,0.05);
    --color-btn-outline-focus-border: #58a6ff;
    --color-btn-outline-focus-shadow: 0 0 0 3px rgba(17,88,199,0.4);
    --color-btn-outline-counter-bg: rgba(31,111,235,0.1);
    --color-btn-danger-text: #f85149;
    --color-btn-danger-hover-text: #fff;
    --color-btn-danger-hover-bg: #da3633;
    --color-btn-danger-hover-border: #f85149;
    --color-btn-danger-hover-shadow: 0 0 transparent;
    --color-btn-danger-hover-inset-shadow: 0 0 transparent;
    --color-btn-danger-hover-counter-bg: hsla(0,0%,100%,0.2);
    --color-btn-danger-selected-text: #fff;
    --color-btn-danger-selected-bg: #b62324;
    --color-btn-danger-selected-border: rgba(240,246,252,0.1);
    --color-btn-danger-selected-shadow: 0 0 transparent;
    --color-btn-danger-disabled-text: rgba(248,81,73,0.5);
    --color-btn-danger-disabled-bg: #0d1117;
    --color-btn-danger-disabled-counter-bg: rgba(218,54,51,0.05);
    --color-btn-danger-focus-border: #f85149;
    --color-btn-danger-focus-shadow: 0 0 0 3px rgba(182,35,36,0.4);
    --color-btn-danger-counter-bg: rgba(218,54,51,0.1);
    --color-btn-danger-icon: #f85149;
    --color-btn-danger-hover-icon: #f0f6fc;
    --color-btn-counter-bg: #30363d;
    --color-counter-text: #c9d1d9;
    --color-counter-bg: #30363d;
    --color-counter-primary-text: #c9d1d9;
    --color-counter-primary-bg: #6e7681;
    --color-counter-secondary-text: #8b949e;
    --color-counter-secondary-bg: rgba(139,148,158,0.2);
    --color-dropdown-shadow: 0 16px 32px rgba(1,4,9,0.85);
    --color-label-border: #30363d;
    --color-label-primary-text: #b1bac4;
    --color-label-primary-border: #6e7681;
    --color-label-secondary-text: #8b949e;
    --color-label-secondary-border: #30363d;
    --color-label-info-text: #388bfd;
    --color-label-info-border: rgba(56,139,253,0.4);
    --color-label-success-text: #3fb950;
    --color-label-success-border: rgba(46,160,67,0.4);
    --color-label-warning-text: #e3b341;
    --color-label-warning-border: rgba(242,211,91,0.4);
    --color-label-danger-text: #f85149;
    --color-label-danger-border: rgba(248,81,73,0.4);
    --color-label-orange-text: #db6d28;
    --color-label-orange-border: rgba(219,109,40,0.4);
    --color-input-bg: #0d1117;
    --color-input-contrast-bg: rgba(1,4,9,0.5);
    --color-input-border: #21262d;
    --color-input-shadow: 0 0 transparent;
    --color-input-disabled-bg: #161b22;
    --color-input-disabled-border: #30363d;
    --color-input-warning-border: #d29922;
    --color-input-error-border: #f85149;
    --color-input-tooltip-success-text: #56d364;
    --color-input-tooltip-success-bg: #101f1b;
    --color-input-tooltip-success-border: #1c532b;
    --color-input-tooltip-warning-text: #e3b341;
    --color-input-tooltip-warning-bg: #1e1c16;
    --color-input-tooltip-warning-border: #5d4411;
    --color-input-tooltip-error-text: #ff7b72;
    --color-input-tooltip-error-bg: #25171c;
    --color-input-tooltip-error-border: #792e2e;
    --color-avatar-bg: rgba(240,246,252,0.1);
    --color-avatar-border: rgba(240,246,252,0.1);
    --color-avatar-stack-fade: #30363d;
    --color-avatar-stack-fade-more: #21262d;
    --color-avatar-child-shadow: -2px -2px 0 #0d1117;
    --color-toast-text: #c9d1d9;
    --color-toast-bg: #30363d;
    --color-toast-border: #6e7681;
    --color-toast-shadow: 0 8px 24px #010409;
    --color-toast-icon: #f0f6fc;
    --color-toast-icon-bg: #1f6feb;
    --color-toast-icon-border: #388bfd;
    --color-toast-success-text: #c9d1d9;
    --color-toast-success-border: #6e7681;
    --color-toast-success-icon: #f0f6fc;
    --color-toast-success-icon-bg: #2ea043;
    --color-toast-success-icon-border: #3fb950;
    --color-toast-warning-text: #c9d1d9;
    --color-toast-warning-border: #6e7681;
    --color-toast-warning-icon: #f0f6fc;
    --color-toast-warning-icon-bg: #bb8009;
    --color-toast-warning-icon-border: #d29922;
    --color-toast-danger-text: #c9d1d9;
    --color-toast-danger-border: #6e7681;
    --color-toast-danger-icon: #f0f6fc;
    --color-toast-danger-icon-bg: #da3633;
    --color-toast-danger-icon-border: #f85149;
    --color-toast-loading-text: #c9d1d9;
    --color-toast-loading-border: #6e7681;
    --color-toast-loading-icon: #f0f6fc;
    --color-toast-loading-icon-bg: #6e7681;
    --color-toast-loading-icon-border: #8b949e;
    --color-timeline-text: #b1bac4;
    --color-timeline-badge-bg: #0d1117;
    --color-timeline-badge-success-border: #2ea043;
    --color-timeline-target-badge-border: #1f6feb;
    --color-timeline-target-badge-shadow: #0d419d;
    --color-select-menu-border-secondary: #30363d;
    --color-select-menu-shadow: 0 0 18px rgba(1,4,9,0.4);
    --color-select-menu-backdrop-bg: rgba(1,4,9,0.5);
    --color-select-menu-backdrop-border: #484f58;
    --color-select-menu-tap-highlight: rgba(48,54,61,0.5);
    --color-select-menu-tap-focus-bg: #0c2d6b;
    --color-box-blue-border: #0d419d;
    --color-box-row-yellow-bg: rgba(235,196,64,0.1);
    --color-box-row-blue-bg: rgba(121,192,255,0.1);
    --color-box-header-blue-bg: #0d1117;
    --color-box-header-blue-border: #30363d;
    --color-box-border-info: rgba(56,139,253,0.4);
    --color-box-bg-info: rgba(56,139,253,0.1);
    --color-box-border-warning: rgba(187,128,9,0.4);
    --color-box-bg-warning: rgba(187,128,9,0.1);
    --color-branch-name-text: #c9d1d9;
    --color-branch-name-icon: #b1bac4;
    --color-branch-name-bg: rgba(88,166,255,0.1);
    --color-branch-name-link-text: #58a6ff;
    --color-branch-name-link-icon: #58a6ff;
    --color-branch-name-link-bg: rgba(88,166,255,0.1);
    --color-markdown-code-bg: rgba(240,246,252,0.15);
    --color-markdown-frame-border: #3b434b;
    --color-markdown-blockquote-border: #3b434b;
    --color-markdown-table-border: #3b434b;
    --color-markdown-table-tr-border: #272c32;
    --color-menu-heading-text: #8b949e;
    --color-menu-border-active: #f78166;
    --color-menu-bg-active: #161b22;
    --color-sidenav-selected-bg: #21262d;
    --color-sidenav-border-active: #f78166;
    --color-header-text: rgba(240,246,252,0.7);
    --color-header-bg: #161b22;
    --color-header-logo: #f0f6fc;
    --color-filter-item-bar-bg: #12161c;
    --color-hidden-text-expander-bg: #21262d;
    --color-hidden-text-expander-bg-hover: #30363d;
    --color-drag-and-drop-border: #25292f;
    --color-upload-enabled-border: #3b434b;
    --color-upload-enabled-border-focused: #4487ee;
    --color-previewable-comment-form-border: #25292f;
    --color-underlinenav-border: rgba(48,54,61,0);
    --color-underlinenav-border-hover: #30363d;
    --color-underlinenav-border-active: #f78166;
    --color-underlinenav-text: #8b949e;
    --color-underlinenav-text-hover: #c9d1d9;
    --color-underlinenav-text-active: #c9d1d9;
    --color-underlinenav-icon: #6e7681;
    --color-underlinenav-icon-hover: #c9d1d9;
    --color-underlinenav-icon-active: #c9d1d9;
    --color-underlinenav-counter-text: #8b949e;
    --color-underlinenav-counter-bg: rgba(139,148,158,0.2);
    --color-verified-badge-text: #3fb950;
    --color-verified-badge-bg: rgba(63,185,80,0.1);
    --color-verified-badge-border: rgba(63,185,80,0.4);
    --color-social-count-bg: #21262d;
    --color-tooltip-text: #f0f6fc;
    --color-tooltip-bg: #6e7681;
    --color-header-search-bg: #0d1117;
    --color-header-search-border: #21262d;
    --color-search-keyword-hl: rgba(187,128,9,0.4);
    --color-diffstat-neutral-bg: #30363d;
    --color-diffstat-neutral-border: rgba(240,246,252,0.1);
    --color-diffstat-deletion-bg: #da3633;
    --color-diffstat-deletion-border: #f85149;
    --color-diffstat-addition-bg: #238636;
    --color-diffstat-addition-border: #2ea043;
    --color-mktg-success: #29933d;
    --color-mktg-info: #2a7bf3;
    --color-mktg-bg-shade-gradient-top: rgba(1,4,9,0.065);
    --color-mktg-bg-shade-gradient-bottom: rgba(1,4,9,0);
    --color-mktg-btn-bg: #1f6feb;
    --color-mktg-btn-border: #1f6feb;
    --color-mktg-btn-text: #f0f6fc;
    --color-mktg-btn-icon: #f0f6fc;
    --color-mktg-btn-focus-shadow: 0 0 0 3px rgba(31,111,235,0.3);
    --color-mktg-btn-hover-bg: #388bfd;
    --color-mktg-btn-hover-border: #388bfd;
    --color-mktg-btn-disabled-bg: rgba(56,139,253,0.5);
    --color-mktg-btn-disabled-border: transparent;
    --color-mktg-btn-disabled-text: rgba(240,246,252,0.5);
    --color-mktg-btn-disabled-icon: rgba(240,246,252,0.5);
    --color-mktg-btn-primary-bg: #238636;
    --color-mktg-btn-primary-border: #238636;
    --color-mktg-btn-primary-text: #f0f6fc;
    --color-mktg-btn-primary-icon: #f0f6fc;
    --color-mktg-btn-primary-focus-shadow: 0 0 0 3px rgba(35,134,54,0.3);
    --color-mktg-btn-primary-hover-bg: #2ea043;
    --color-mktg-btn-primary-hover-border: #2ea043;
    --color-mktg-btn-primary-disabled-bg: rgba(46,160,67,0.5);
    --color-mktg-btn-primary-disabled-border: transparent;
    --color-mktg-btn-primary-disabled-text: rgba(240,246,252,0.5);
    --color-mktg-btn-primary-disabled-icon: rgba(240,246,252,0.5);
    --color-mktg-btn-outline-bg: transparent;
    --color-mktg-btn-outline-border: rgba(56,139,253,0.5);
    --color-mktg-btn-outline-text: #388bfd;
    --color-mktg-btn-outline-icon: #388bfd;
    --color-mktg-btn-outline-focus-shadow: 0 0 0 3px rgba(56,139,253,0.3);
    --color-mktg-btn-outline-hover-bg: transparent;
    --color-mktg-btn-outline-hover-border: #388bfd;
    --color-mktg-btn-outline-hover-text: #58a6ff;
    --color-mktg-btn-outline-hover-icon: #58a6ff;
    --color-mktg-btn-outline-disabled-bg: transparent;
    --color-mktg-btn-outline-disabled-border: rgba(56,139,253,0.2);
    --color-mktg-btn-outline-disabled-text: rgba(56,139,253,0.5);
    --color-mktg-btn-outline-disabled-icon: rgba(56,139,253,0.5);
    --color-mktg-btn-dark-bg: transparent;
    --color-mktg-btn-dark-border: rgba(201,209,217,0.5);
    --color-mktg-btn-dark-text: #c9d1d9;
    --color-mktg-btn-dark-icon: #c9d1d9;
    --color-mktg-btn-dark-focus-shadow: 0 0 0 3px rgba(201,209,217,0.3);
    --color-mktg-btn-dark-hover-bg: rgba(201,209,217,0.5);
    --color-mktg-btn-dark-hover-border: rgba(201,209,217,0.5);
    --color-mktg-btn-dark-hover-text: #0d1117;
    --color-mktg-btn-dark-hover-icon: #0d1117;
    --color-mktg-btn-dark-disabled-bg: transparent;
    --color-mktg-btn-dark-disabled-border: rgba(201,209,217,0.2);
    --color-mktg-btn-dark-disabled-text: rgba(201,209,217,0.5);
    --color-mktg-btn-dark-disabled-icon: rgba(201,209,217,0.5);
    --color-files-explorer-icon: #6e7681;
    --color-hl-author-bg: #051d4d;
    --color-hl-author-border: #0d419d;
    --color-logo-subdued: #30363d;
    --color-discussion-border: #34513b;
    --color-discussion-bg-success: rgba(46,160,67,0.1);
    --color-actions-workflow-table-sticky-bg: rgba(13,17,23,0.95);
    --color-repo-language-color-border: rgba(240,246,252,0.2);
    --color-code-selection-bg: rgba(121,192,255,0.3);
    --color-highlight-text: #ffd467;
    --color-highlight-bg: rgba(204,143,44,0.38);
    --color-blob-line-highlight-bg: rgba(210,153,34,0.15);
    --color-blob-line-highlight-border: #e3b341;
    --color-diff-addition-text: #56d364;
    --color-diff-addition-bg: rgba(46,160,67,0.2);
    --color-diff-addition-border: #196c2e;
    --color-diff-deletion-text: #f85149;
    --color-diff-deletion-bg: rgba(218,54,51,0.2);
    --color-diff-deletion-border: #b62324;
    --color-diff-change-text: #e3b341;
    --color-diff-change-bg: #341a00;
    --color-diff-change-border: #9e6a03;
    --color-diff-blob-num-text: rgba(240,246,252,0.3);
    --color-diff-blob-num-hover-text: rgba(240,246,252,0.6);
    --color-diff-blob-addition-num-text: #3fb950;
    --color-diff-blob-addition-num-hover-text: #7ee787;
    --color-diff-blob-addition-num-bg: rgba(46,160,67,0.1);
    --color-diff-blob-addition-line-bg: rgba(46,160,67,0.2);
    --color-diff-blob-addition-word-bg: rgba(46,160,67,0.55);
    --color-diff-blob-deletion-num-text: #f85149;
    --color-diff-blob-deletion-num-hover-text: #ffa198;
    --color-diff-blob-deletion-num-bg: rgba(218,54,51,0.1);
    --color-diff-blob-deletion-line-bg: rgba(218,54,51,0.2);
    --color-diff-blob-deletion-word-bg: rgba(218,54,51,0.5);
    --color-diff-blob-hunk-text: #8b949e;
    --color-diff-blob-hunk-num-bg: rgba(88,166,255,0.15);
    --color-diff-blob-hunk-line-bg: rgba(88,166,255,0.1);
    --color-diff-blob-empty-block-bg: #161b22;
    --color-diff-blob-selected-line-highlight-bg: rgba(187,128,9,0.1);
    --color-diff-blob-selected-line-highlight-border: #bb8009;
    --color-diff-blob-selected-line-highlight-mix-blend-mode: normal;
    --color-diff-blob-expander-icon: #8b949e;
    --color-diff-blob-expander-hover-icon: #f0f6fc;
    --color-diff-blob-expander-hover-bg: #1f6feb;
    --color-diff-blob-comment-button-icon: #f0f6fc;
    --color-diff-blob-comment-button-bg: #1f6feb;
    --color-diff-blob-comment-button-gradient-bg: #367eed;
    --color-global-nav-logo: #f0f6fc;
    --color-global-nav-bg: #161b22;
    --color-global-nav-text: #c9d1d9;
    --color-global-nav-icon: #c9d1d9;
    --color-global-nav-input-bg: #0d1117;
    --color-global-nav-input-border: #21262d;
    --color-global-nav-input-icon: #21262d;
    --color-global-nav-input-placeholder: #484f58;
    --color-calendar-graph-day-bg: #161b22;
    --color-calendar-graph-day-border: rgba(27,31,35,0.06);
    --color-calendar-graph-day-L1-bg: #003820;
    --color-calendar-graph-day-L2-bg: #00602d;
    --color-calendar-graph-day-L3-bg: #10983d;
    --color-calendar-graph-day-L4-bg: #27d545;
    --color-calendar-graph-day-L4-border: hsla(0,0%,100%,0.05);
    --color-calendar-graph-day-L3-border: hsla(0,0%,100%,0.05);
    --color-calendar-graph-day-L2-border: hsla(0,0%,100%,0.05);
    --color-calendar-graph-day-L1-border: hsla(0,0%,100%,0.05);
    --color-footer-invertocat-octicon: #30363d;
    --color-footer-invertocat-octicon-hover: #6e7681;
    --color-pr-state-draft-text: #8b949e;
    --color-pr-state-draft-bg: rgba(139,148,158,0.1);
    --color-pr-state-draft-border: rgba(139,148,158,0.4);
    --color-pr-state-open-text: #3fb950;
    --color-pr-state-open-bg: rgba(63,185,80,0.1);
    --color-pr-state-open-border: rgba(63,185,80,0.4);
    --color-pr-state-merged-text: #a371f7;
    --color-pr-state-merged-bg: rgba(188,140,255,0.1);
    --color-pr-state-merged-border: rgba(188,140,255,0.4);
    --color-pr-state-closed-text: #f85149;
    --color-pr-state-closed-bg: rgba(218,54,51,0.1);
    --color-pr-state-closed-border: rgba(218,54,51,0.4);
    --color-topic-tag-text: #58a6ff;
    --color-topic-tag-bg: rgba(56,139,253,0.1);
    --color-topic-tag-hover-bg: rgba(56,139,253,0.2);
    --color-topic-tag-active-bg: rgba(56,139,253,0.15);
    --color-merge-box-success-icon-bg: rgba(46,160,67,0.1);
    --color-merge-box-success-icon-text: #3fb950;
    --color-merge-box-success-icon-border: rgba(46,160,67,0.4);
    --color-merge-box-success-indicator-bg: #238636;
    --color-merge-box-success-indicator-border: #2ea043;
    --color-merge-box-merged-icon-bg: rgba(188,140,255,0.1);
    --color-merge-box-merged-icon-text: #a371f7;
    --color-merge-box-merged-icon-border: rgba(188,140,255,0.4);
    --color-merge-box-merged-box-border: rgba(188,140,255,0.4);
    --color-merge-box-neutral-icon-bg: rgba(201,209,217,0.1);
    --color-merge-box-neutral-icon-text: #8b949e;
    --color-merge-box-neutral-icon-border: rgba(201,209,217,0.4);
    --color-merge-box-neutral-indicator-bg: #484f58;
    --color-merge-box-neutral-indicator-border: #6e7681;
    --color-merge-box-warning-icon-bg: rgba(187,128,9,0.1);
    --color-merge-box-warning-icon-text: #e3b341;
    --color-merge-box-warning-icon-border: rgba(187,128,9,0.4);
    --color-merge-box-warning-box-border: rgba(187,128,9,0.4);
    --color-merge-box-warning-merge-highlight: rgba(187,128,9,0.1);
    --color-merge-box-error-icon-bg: rgba(248,81,73,0.1);
    --color-merge-box-error-icon-text: #f85149;
    --color-merge-box-error-icon-border: rgba(248,81,73,0.4);
    --color-merge-box-error-indicator-bg: #da3633;
    --color-merge-box-error-indicator-border: #f85149;
    --color-project-card-bg: #161b22;
    --color-project-header-bg: #0d1117;
    --color-project-sidebar-bg: #161b22;
    --color-project-gradient-in: #161b22;
    --color-project-gradient-out: rgba(22,27,34,0);
    --color-checks-bg: #090c10;
    --color-checks-run-border-width: 1px;
    --color-checks-container-border-width: 1px;
    --color-checks-text-primary: #c9d1d9;
    --color-checks-text-secondary: #8b949e;
    --color-checks-text-link: #58a6ff;
    --color-checks-btn-icon: #6e7681;
    --color-checks-btn-hover-icon: #c9d1d9;
    --color-checks-btn-hover-bg: #30363d;
    --color-checks-input-text: #8b949e;
    --color-checks-input-placeholder-text: #484f58;
    --color-checks-input-focus-text: #c9d1d9;
    --color-checks-input-bg: #0d1117;
    --color-checks-input-shadow: 0 0 0 1px #21262d;
    --color-checks-dropdown-text: #c9d1d9;
    --color-checks-dropdown-bg: #21262d;
    --color-checks-dropdown-border: #30363d;
    --color-checks-dropdown-hover-text: #f0f6fc;
    --color-checks-dropdown-hover-bg: #1f6feb;
    --color-checks-dropdown-btn-hover-text: #f0f6fc;
    --color-checks-dropdown-btn-hover-bg: #161b22;
    --color-checks-scrollbar-thumb-bg: #30363d;
    --color-checks-header-label-text: #8b949e;
    --color-checks-header-label-open-text: #c9d1d9;
    --color-checks-header-border: #21262d;
    --color-checks-header-icon: #6e7681;
    --color-checks-line-text: #8b949e;
    --color-checks-line-num-text: #8b949e;
    --color-checks-line-timestamp-text: #8b949e;
    --color-checks-line-hover-bg: #161b22;
    --color-checks-line-selected-bg: rgba(56,139,253,0.1);
    --color-checks-line-selected-num-text: #58a6ff;
    --color-checks-line-dt-fm-text: #0d1117;
    --color-checks-line-dt-fm-bg: #d29922;
    --color-checks-gate-bg: rgba(132,83,6,0.15);
    --color-checks-gate-text: #8b949e;
    --color-checks-gate-waiting-text: #e3b341;
    --color-checks-step-header-open-bg: #161b22;
    --color-checks-step-error-text: #f85149;
    --color-checks-step-warning-text: #e3b341;
    --color-checks-logline-text: #6e7681;
    --color-checks-logline-num-text: #8b949e;
    --color-checks-logline-debug-text: #bc8cff;
    --color-checks-logline-error-text: #8b949e;
    --color-checks-logline-error-num-text: #8b949e;
    --color-checks-logline-error-bg: rgba(248,81,73,0.1);
    --color-checks-logline-warning-text: #8b949e;
    --color-checks-logline-warning-num-text: #e3b341;
    --color-checks-logline-warning-bg: rgba(187,128,9,0.1);
    --color-checks-logline-command-text: #58a6ff;
    --color-checks-logline-section-text: #56d364;
    --color-intro-shelf-gradient-left: rgba(56,139,253,0.1);
    --color-intro-shelf-gradient-right: rgba(46,160,67,0.1);
    --color-intro-shelf-gradient-in: #0d1117;
    --color-intro-shelf-gradient-out: rgba(13,17,23,0);
    --color-marketing-icon-primary: #79c0ff;
    --color-marketing-icon-secondary: #1f6feb;
    --color-prettylights-syntax-comment: #8b949e;
    --color-prettylights-syntax-constant: #79c0ff;
    --color-prettylights-syntax-entity: #d2a8ff;
    --color-prettylights-syntax-storage-modifier-import: #c9d1d9;
    --color-prettylights-syntax-entity-tag: #7ee787;
    --color-prettylights-syntax-keyword: #ff7b72;
    --color-prettylights-syntax-string: #a5d6ff;
    --color-prettylights-syntax-variable: #ffa657;
    --color-prettylights-syntax-brackethighlighter-unmatched: #f85149;
    --color-prettylights-syntax-invalid-illegal-text: #f0f6fc;
    --color-prettylights-syntax-invalid-illegal-bg: #8e1519;
    --color-prettylights-syntax-carriage-return-text: #f0f6fc;
    --color-prettylights-syntax-carriage-return-bg: #b62324;
    --color-prettylights-syntax-string-regexp: #7ee787;
    --color-prettylights-syntax-markup-list: #f2cc60;
    --color-prettylights-syntax-markup-heading: #1f6feb;
    --color-prettylights-syntax-markup-italic: #c9d1d9;
    --color-prettylights-syntax-markup-bold: #c9d1d9;
    --color-prettylights-syntax-markup-deleted-text: #ffdcd7;
    --color-prettylights-syntax-markup-deleted-bg: #67060c;
    --color-prettylights-syntax-markup-inserted-text: #aff5b4;
    --color-prettylights-syntax-markup-inserted-bg: #033a16;
    --color-prettylights-syntax-markup-changed-text: #ffdfb6;
    --color-prettylights-syntax-markup-changed-bg: #5a1e02;
    --color-prettylights-syntax-markup-ignored-text: #c9d1d9;
    --color-prettylights-syntax-markup-ignored-bg: #1158c7;
    --color-prettylights-syntax-meta-diff-range: #d2a8ff;
    --color-prettylights-syntax-brackethighlighter-angle: #8b949e;
    --color-prettylights-syntax-sublimelinter-gutter-mark: #484f58;
    --color-prettylights-syntax-constant-other-reference-link: #a5d6ff;
    --color-codemirror-text: #c9d1d9;
    --color-codemirror-bg: #0d1117;
    --color-codemirror-gutters-bg: #0d1117;
    --color-codemirror-guttermarker-text: #0d1117;
    --color-codemirror-guttermarker-subtle-text: #6e7681;
    --color-codemirror-linenumber-text: #8b949e;
    --color-codemirror-cursor: #f0f6fc;
    --color-codemirror-selection-bg: rgba(121,192,255,0.3);
    --color-codemirror-activeline-bg: #161b22;
    --color-codemirror-matchingbracket-text: #c9d1d9;
    --color-codemirror-lines-bg: #0d1117;
    --color-codemirror-syntax-comment: #8b949e;
    --color-codemirror-syntax-constant: #79c0ff;
    --color-codemirror-syntax-entity: #d2a8ff;
    --color-codemirror-syntax-keyword: #ff7b72;
    --color-codemirror-syntax-storage: #ff7b72;
    --color-codemirror-syntax-string: #a5d6ff;
    --color-codemirror-syntax-support: #79c0ff;
    --color-codemirror-syntax-variable: #ffa657;
    --color-ansi-black: #0d1117;
    --color-ansi-black-bright: #161b22;
    --color-ansi-white: #b1bac4;
    --color-ansi-white-bright: #b1bac4;
    --color-ansi-gray: #6e7681;
    --color-ansi-red: #ff7b72;
    --color-ansi-red-bright: #ffa198;
    --color-ansi-green: #3fb950;
    --color-ansi-green-bright: #56d364;
    --color-ansi-yellow: #d29922;
    --color-ansi-yellow-bright: #e3b341;
    --color-ansi-blue: #58a6ff;
    --color-ansi-blue-bright: #79c0ff;
    --color-ansi-magenta: #bc8cff;
    --color-ansi-magenta-bright: #d2a8ff;
    --color-ansi-cyan: #76e3ea;
    --color-ansi-cyan-bright: #b3f0ff;
}

.root {
  color: var(--primaryAPPL);
}

a.btn-xyz {
  text-decoration: none;
}

.btn-xyz {
  display: inline-block;
  align-items: center;
  text-align: center;
  font-size: 14px;
  justify-content: center;
  border: 0.1em solid #ffffff;
  box-sizing: border-box;
  text-decoration: none;
  font: 400 13.3333px Arial;
  transition: all 0.2s;
  cursor: pointer;
  user-select: none;
}


.btn-xyz:focus {
  outline: none;
}

.btn-xyz:hover {
  outline: none;
}

.btn-xyz:disabled {
  outline: none;
}

.btn--primary--solid {
  background-color: var(--primary50);
  opacity: 1;
  color: currentColor;
}

.btn--primary--solid:active {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--primary50);
  color: var(--primary50);
}

.btn--primary--solid:hover {
  opacity: 0.7;
  transition: none;
}

.btn--primary--solid:disabled {
  border: 0.1em solid var(--border-color);
  background-color: var(--primary50);
  color: var(--white);
  opacity: 0.4;
}



.btn--primary--text {
  background-color: var(--trasparent);
  border: 0.1em solid var(--trasparent);
  opacity: 1;
  color: var(--primary50);
}

.btn--primary--text:active {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--trasparent);
  color: currentColor;
}

.btn--primary--text:hover {
  opacity: 0.7;
  transition: none;
}

.btn--primary--text:disabled {
  border: 0.1em solid var(--trasparent);
  background-color: var(--trasparent);
  color: var(--primary50);
  opacity: 0.4;
}

.btn--primary--outline {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--primary50);
  color: var(--primary50);
}



.btn--primary--outline:hover {
  opacity: 0.7;
  transition: none;
}

.btn--primary--outline:disabled {
  border: 0.1em solid var(--primary50);
  background-color: var(--transparent);
  color: var(--primary50);
  opacity: 0.4;
}

.btn--secondary--solid {
  background-color: var(--secondary50);
  opacity: 1;
  color: var(--white);
}
.btn--secondary--solid:hover {
  opacity: 0.7;
  transition: none;
}

.btn--secondary--solid:focus {
  background-color: var(--focus);
  border: 0.1em solid var(--secondary50);
  opacity: 1;
  color: var(--secondary50);
}

.btn--secondary--outline {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--secondary50);
  color: var(--secondary50);
}

.btn--secondary--outline:focus {
  background-color: var(--focus);
  opacity: 1;
  color: var(--secondary50);
}

.btn--secondary--outline:hover {
  opacity: 0.7;
  transition: none;

}

.btn--secondary--outline:disabled {
  border: 0.1em solid var(--border-color);
  background-color: var(--transparent);
  color: var(--secondary50);
  opacity: 0.4;
}

.btn--danger--solid {
  background-color: var(--danger50);
  opacity: 1;
  color: var(--white);
}
.btn--danger--solid:hover {
  opacity: 0.7;
  transition: none;
}

.btn--danger--solid:focus {
  background-color: var(--focus);
  border: 0.1em solid var(--danger50);
  opacity: 1;
  color: var(--danger50);
}

.btn--danger--outline {
  background-color: var(--trasparent);
  opacity: 1;
  border: 0.1em solid var(--danger50);
  border-radius: 1.12em;
  color: var(--danger50);
}

.btn--danger--outline:focus {
  background-color: var(--focus);
  opacity: 1;
  color: var(--danger50);
}

.btn--danger--outline:hover {
  opacity: 0.7;
  transition: none;

}

.btn--danger--outline:disabled {
  border: 0.1em solid var(--border-color);
  background-color: var(--transparent);
  color: var(--danger50);
  opacity: 0.4;
}

.btn--round {
  border-radius: 1.12em;
}

.btn--square {
  border-radius: 0.22em;
}

.btn--xs {
  padding: 0 0.6rem 1.2px 0.6rem;
  margin: 0.6em;
}

.btn--sm {
  padding: 0.2em 1.6em;
  margin: 0.6em;
  font-size: 15px;
}

.btn--md {
  padding: 0.3em 2em;
  margin: 0.6em;
  font-size: 16px;
}

.btn--lg {
  padding: 0.4em 2.4em;
  margin: 0.6em;
  font-size: 17px;
}

.btn--xl {
  padding: 0.5em 2.8em;
  margin: 0.6em;
  font-size: 18px;
}

body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-family: "Proxima Nova Regular", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
  }

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.scrollbartrackbgcolor};
}

::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.scrollbarbgcolor};
    border-radius: 0px;
    border: ${({ theme }) => theme.scrollbarborder};
}

.MuiToolbar-root {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.bartext};
}

.MuiBottomNavigation-root {
    background: ${({ theme }) => theme.bottomnavbgcolor};
}

.MuiToolbar-root.MuiToolbar-regular.toolbar-style.MuiToolbar-gutters {
    padding: 0 16px !important;

}
.MuiPaper-root.MuiDrawer-paper.paper.makeStyles-drawerClose-8.MuiDrawer-paperAnchorLeft.MuiDrawer-paperAnchorDockedLeft.MuiPaper-elevation0 {
    border-right: #878787 dotted 0.1px;
}
.MuiPaper-root.MuiDrawer-paper.paper.makeStyles-drawerOpen-7.MuiDrawer-paperAnchorLeft.MuiDrawer-paperAnchorDockedLeft.MuiPaper-elevation0 {
    border-right: #878787 dotted 0.1px;
}

.MuiPaper-root.MuiDialog-paper.MuiDialog-paperScrollPaper.MuiDialog-paperWidthSm.MuiDialog-paperFullScreen.MuiPaper-elevation24.MuiPaper-rounded {
    background-color: ${({ theme }) => theme.dialog};
    color: ${({ theme }) => theme.text};
    font-family: "Proxima Nova Regular", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-weight: 400;
}

p.MuiTypography-root.MuiDropzoneArea-text.MuiTypography-h5 {
    color: ${({ theme }) => theme.inverse};
}


.MuiChip-root.MuiChip-outlined.MuiChip-deletable {
    color: ${({ theme }) => theme.iconcolor};
    border: ${({ theme }) => theme.borderstyle};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

svg.MuiSvgIcon-root.MuiChip-deleteIcon {
    color: ${({ theme }) => theme.iconcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.stepperPaper {
    background-color: ${({ theme }) => theme.stepperpaper};
    color: ${({ theme }) => theme.steppercolor};   
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.modalPaper {
    background-color: ${({ theme }) => theme.tabbar};
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    width: 100%;
    height: 100%;
}


hr.MuiDivider-root {
    border-bottom: #878787 solid 0.1px;
}

.MuiTypography-colorTextSecondary {
    color: ${({ theme }) => theme.textsecondary};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiPaper-root.MuiDrawer-paper.MuiDrawer-paperAnchorRight.MuiPaper-elevation16 {
    background: ${({ theme }) => theme.menubackground};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiPaper-root.MuiDrawer-paper.makeStyles-drawerPaper-7.MuiDrawer-paperAnchorLeft.MuiDrawer-paperAnchorDockedLeft.MuiPaper-elevation0 {
    ${'' /* background: ${({ theme }) => theme.chatboxbackground}; */}
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.skeleton.MuiSkeleton-root {
    background-color: ${({ theme }) => theme.skeleton};
}

.skeleton-light.MuiSkeleton-root {
    background-color: ${({ theme }) => theme.skeletonlight};
}

span.MuiTypography-root.MuiStepLabel-label.MuiStepLabel-alternativeLabel.MuiStepLabel-active.MuiTypography-body2.MuiTypography-displayBlock {
    color: ${({ theme }) => theme.whiteform};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

span.MuiTypography-root.MuiStepLabel-label.MuiStepLabel-alternativeLabel.MuiTypography-body2.MuiTypography-displayBlock {
    color: ${({ theme }) => theme.whiteformlight};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiAppBar-colorPrimary {
    color: ${({ theme }) => theme.tabbarcolor};
    background-color: ${({ theme }) => theme.tabbar};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.PrivateTabIndicator-colorSecondary-177 {
    background-color: ${({ theme }) => theme.tabsunderline};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiTab-textColorInherit {
    color: ${({ theme }) => theme.tabbarcolor};
    background-color: ${({ theme }) => theme.tabbar};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
    outline: none;
}

.tabs-body {
    background-color: ${({ theme }) => theme.tabsbody};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiBox-root {
    background-color: ${({ theme }) => theme.tabsbody};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.toolbar-style {
    background: ${({ theme }) => theme.bar};
    color: ${({ theme }) => theme.bartext};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}


.MuiTableContainer-root {
    border-radius: 8px;
    box-shadow: ${({ theme }) => theme.barshadow};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms; 
}

.MuiTableHead-root {
    background-color: ${({ theme }) => theme.tabbar};
    color: ${({ theme }) => theme.bartext};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiTableBody-root {
    color: ${({ theme }) => theme.bartext};
    background-color: ${({ theme }) => theme.tabsbody};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiSlider-root {
    color: ${({ theme }) => theme.redthumb};
    ${'' /* background: ${({ theme }) => theme.body}; */}
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiSlider-thumb.MuiSlider-thumbColorPrimary.PrivateValueLabel-open-10.PrivateValueLabel-thumb-9 {
    color: ${({ theme }) => theme.redthumb};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiSlider-track{
    color: ${({ theme }) => theme.redthumb};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiSlider-rail {
    color: ${({ theme }) => theme.redthumb};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiSlider-mark {
    color: ${({ theme }) => theme.inversetext};

}
 .MuiSlider-markActive {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.MuiSlider-markLabel {
    color: ${({ theme }) => theme.marklabelia};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiSlider-markLabel.MuiSlider-markLabelActive {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiSwitch-switchBase {
    color: ${({ theme }) => theme.dark50};
}

.MuiSwitch-track {
    background-color: ${({ theme }) => theme.dark40};
}

.MuiSwitch-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.primary40};
}

.MuiSwitch-colorPrimary.Mui-checked {
    color: ${({ theme }) => theme.primary40};
}

.MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
    background-color: ${({ theme }) => theme.primary40};
}

.MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
    user-select: none;
}

.switch-thumb {
    color: ${({ theme }) => theme.primary60};
}

.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
    background-color: ${({ theme }) => theme.primary40};
}

.MuiFormLabel-root.Mui-disabled {
    color: ${({ theme }) => theme.disabledtextcolor};
}

.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.disabledtextcolor};
}

.MuiFormHelperText-root {
    color: ${({ theme }) => theme.helpretextcolor};
}

.MuiDataGrid-root {
    color: ${({ theme }) => theme.text};
}

.MuiDataGrid-columnHeaderWrapper {
    color: ${({ theme }) => theme.helpretextcolor};
}

.MuiIconButton-root {
    color: ${({ theme }) => theme.helpretextcolor};
}

.MuiMenuItem-root {
    color: ${({ theme }) => theme.dark40 + '!important'};

}

.MuiButtonBase-root {
    color: rgb(138 138 138 / 80%);
    
}

.MuiDataGrid-cell.MuiDataGrid-cell--textLeft {
    color: ${({ theme }) => theme.text};
}

.MuiDataGrid-root .MuiDataGrid-booleanCell[data-value="false"] {
    color: ${({ theme }) => theme.helpretextcolor};
}

.MuiDataGrid-root .MuiDataGrid-booleanCell[data-value="true"]
{
    color: ${({ theme }) => theme.helpretextcolor};
}

.MuiInput-underline:after {
    border-bottom: 2px solid ${({ theme }) => theme.primary40};
}

.MuiFormLabel-root.Mui-focused {
    color: ${({ theme }) => theme.primary40};
}

.MuiBadge-colorPrimary {
    background-color: ${({ theme }) => theme.primary40};
}

.MuiDataGrid-root.MuiDataGrid-columnHeader:focus, .MuiDataGrid-root.MuiDataGrid-cell:focus {
    background-color: ${({ theme }) => theme.primary50};
}

.MuiCheckbox-colorPrimary.Mui-checked {
    color: ${({ theme }) => theme.primary30};
}

.tag-color {
    color: ${({ theme }) => theme.tagcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.bottom-border {
    border-bottom: ${({ theme }) => theme.bottomborder};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.logo-img {
    background-image: ${({ theme }) => theme.logoimg};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.git-img {
    background-image: ${({ theme }) => theme.gitimg};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.img-border {
    border: ${({ theme }) => theme.imgborder};
    border-radius: 5%;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.small-img-border {
    border: ${({ theme }) => theme.imgborder};
    border-radius: 15%;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.npm-box {
    box-shadow: rgb(95, 13, 13) 0px 0px 15px 0px, rgb(95, 13, 13) 0px 0px 0px 0px, rgb(95, 13, 13) 0px 0px 0px 0px;
    background-color: ${({ theme }) => theme.npmbackground};
    border: 1px solid rgb(204 0 0 / 49%);
    opacity: ${({ theme }) => theme.npmopacity};
}

.npm-box:hover {
    box-shadow: rgb(95, 13, 13) 0px 0px 20px 0px, rgb(95, 13, 13) 0px 0px 0px 0px, rgb(95, 13, 13) 0px 0px 0px 0px;
    background-color: ${({ theme }) => theme.npmbackground};
    border: 1px solid rgb(204 0 0 / 69%);
    opacity: 0.8;
}


.git-box {
    box-shadow: ${({ theme }) => theme.gitshadow};
    background-color: ${({ theme }) => theme.gitbackground};
    border: ${({ theme }) => theme.gitborder};
    opacity: ${({ theme }) => theme.gitopacity};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.git-box:hover {
    box-shadow: ${({ theme }) => theme.gitshadowhover};
    background-color: ${({ theme }) => theme.gitbackground};
    border: ${({ theme }) => theme.gitborderhover};
    opacity: 0.8;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.dbfc {
    box-shadow: ${({ theme }) => theme.dbcshadow};
    background-color: ${({ theme }) => theme.dbcbackground};
    border: ${({ theme }) => theme.dbcborder};
    opacity: 0.7;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.dbfc:hover {
    box-shadow: ${({ theme }) => theme.dbcshadowhover};
    background-color: ${({ theme }) => theme.dbcbackground};
    border: ${({ theme }) => theme.dbcborderhover};
    opacity: 0.9;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.button-border {
    border: ${({ theme }) => theme.buttonborder};
    border-radius: 2%;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.icon-color {
    color: ${({ theme }) => theme.iconcolor};
}

.bar-shadow {
    box-shadow: ${({ theme }) => theme.barshadow};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.menu-icon {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}
.bar-title {
    color: ${({ theme }) => theme.bartext};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    letter-spacing: 0.2rem;
    text-transform: uppercase;
}

.icon {
    color: ${({ theme }) => theme.iconcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.link-style, .link-style:hover {
    color: ${({ theme }) => theme.text};
    text-decoration: none;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.list-style {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}


.theme-position {
    color: ${({ theme }) => theme.text};
    position: unset;
    margin-top: 18px;
}

.global-container {
    color: ${({ theme }) => theme.text};
    background: ${({ theme }) => theme.globalbackground};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.drawer-color {
    background: ${({ theme }) => theme.menubackground};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.drawer-text {
    color: ${({ theme }) => theme.menutextcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.paper {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    border-right: #878787 dotted 0.1px;
}

.text-color {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.link-color {
    color: ${({ theme }) => theme.linkcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.backround-color {
    background: ${({ theme }) => theme.body};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.text-secondary {
    color: ${({ theme }) => theme.textsecondary};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}
.body-content {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.divider {
    color: ${({ theme }) => theme.divider};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

  }

  .dev-ops-container {
    width: 100%;
  }


  .card-body-color {
    background: ${({ theme }) => theme.cardbg};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.card-text-color {
    color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}
.card-border-color {
    border: ${({ theme }) => theme.cardborder};
}

.border-color {
    border: ${({ theme }) => theme.bordercolor};
}

.card-shadow-color {
    box-shadow: ${({ theme }) => theme.cardshadow};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.card-hr {
    margin: 0 14px;
    border-top: ${({ theme }) => theme.hrcolor} !important;
}


svg.MuiSvgIcon-root.MuiSelect-icon.MuiSelect-iconOutlined {
    color: ${({ theme }) => theme.textfieldtextcolor};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.PrivateNotchedOutline-legendLabelled-8 {
    -webkit-transition: max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms;

}

.text-field-style {
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    & input {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & textarea {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & select {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & select:not([multiple]) option, select:not([multiple]) optgroup {
        background: ${({ theme }) => theme.cardbg};
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & label {
        color: ${({ theme }) => theme.textfieldtextcolor};
    }
    & label.Mui-focused {
        color: ${({ theme }) => theme.textfieldtextcolor};
    },
    & .MuiInput-underline:after {
        border-bottom-color: #3f3f3f;
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    },
    & .MuiOutlinedInput-root {
        & fieldset {
            border-color: ${({ theme }) => theme.textfieldoutlinecolor};
        },
        &:hover fieldset {
            border-color: ${({ theme }) => theme.textfieldoutlinecolorhover};
        },
        &.Mui-focused fieldset {
            border-color: #9b9b9b;
        },
    }
}

${
  '' /* & input:valid + fieldset {
    border-color: var(--green);
    color: var(--green);
},
& input:invalid + fieldset {
    border-color: var(--red);
    color: var(--red);
} */
}
.link-text-field-style {
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    & input {
        color: ${({ theme }) => theme.linkcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & textarea {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & select {
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & select:not([multiple]) option, select:not([multiple]) optgroup {
        background: ${({ theme }) => theme.cardbg};
        color: ${({ theme }) => theme.textfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    }
    & label {
        color: ${({ theme }) => theme.textfieldtextcolor};
    }
    & label.Mui-focused {
        color: ${({ theme }) => theme.textfieldtextcolor};
    },
    & .MuiInput-underline:after {
        border-bottom-color: #3f3f3f;
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
    },
    & .MuiOutlinedInput-root {
        & fieldset {
            border-color: ${({ theme }) => theme.textfieldoutlinecolor};
        },
        &:hover fieldset {
            border-color: ${({ theme }) => theme.textfieldoutlinecolorhover};
        },
        &.Mui-focused fieldset {
            border-color: #9b9b9b;
        },
    }
}

.text-field-light-style {
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    & input {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & textarea {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & select {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & select:not([multiple]) option, select:not([multiple]) optgroup {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    }
    & label {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};

    }
    & label.Mui-focused {
        color: ${({ theme }) => theme.lighttextfieldtextcolor};

    },
    & .MuiInput-underline:after {
        border-bottom-color: #3f3f3f;
        transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

    },
    & .MuiOutlinedInput-root {
        & fieldset {
            border-color: ${({ theme }) => theme.lighttextfieldoutlinecolor};
        },
        &:hover fieldset {
            border-color: ${({ theme }) =>
              theme.lighttextfieldoutlinecolorhover};
        },
        &.Mui-focused fieldset {
            border-color: #9b9b9b;
        },
    }
}



${
  '' /* & input:valid + fieldset {
    border-color: var(--green);
    color: var(--green);
},
& input:invalid + fieldset {
    border-color: var(--red);
    color: var(--red);
} */
}


.MuiStepIcon-root.MuiStepIcon-active {
    color: #545454;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiStepIcon-root.MuiStepIcon-completed {
    color: #b53f3f;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}


.MuiRadio-colorSecondary.Mui-checked {
    color: #b53f3f;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiIconButton-colorSecondary {
    color: #b53f3f;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiRadio-colorPrimary.Mui-checked {
    color: #004a99;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}

.MuiIconButton-colorPrimary {
    color: #004a99;
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;
}





.button-color {
    color: ${({ theme }) => theme.buttontextcolor};
    background: ${({ theme }) => theme.buttonbgcolor};
    box-shadow: ${({ theme }) => theme.cardshadow};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.button-color:hover {
    background: ${({ theme }) => theme.buttonbgcolorhover};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}


.MuiButtonGroup-groupedOutlinedHorizontal {
    /* border-right-color: white; */
    border-color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.MuiButtonGroup-groupedOutlinedHorizontal:not(:last-child) {
    /* : transparent; */
    border-right-color: ${({ theme }) => theme.text};
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

input {
    transition: width 0.2s cubic-bezier(0.4, 0, 0.6, 1) 0ms,margin 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0ms;

}

.MuiButton-root.Mui-disabled {
    color: ${({ theme }) => theme.disabledtextcolor};
}

.MuiButton-outlined.Mui-disabled {
    border: 1px solid ${({ theme }) => theme.disabledtextcolor};
}






















#designer {
    background: radial-gradient(
        circle at 20% 128%,
        #2b31fa 15%,
        #ab771d 35%,
        #9e1b3c 55%,
        #178085 75%,
        #d60000 95%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    border-style: groove;
    border-width: 1px;
}
#super {
    border-style: double;
    border-width: 1px;
    border-color: rgb(131, 131, 131);
}
#photographer {
    border: dotted;
    border-width: 1px;
    border-color: rgb(10, 10, 10);
}
#developer {
    border-width: 1px;
    border-color: rgb(236, 236, 236);
    border-style: dotted;
}
#admin-badge {
    border-width: 1px;
    border-color: rgb(214, 214, 214);
    border-style: dotted;
}

/*
 Social Media Icons Styles
 */

.insta {
    background: radial-gradient(
        circle at 30% 107%,
        #fdf497 0%,
        #fdf497 5%,
        #fd5949 45%,
        #d6249f 60%,
        #285aeb 90%
    );
    -webkit-background-clip: text;
    /* Also define standard property for compatibility */
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.linkedin {
    color: #0074b0;
}
.twitter {
    color: #1da1f2;
}

.facebook {
    color: #4064ad;
}
.whatsapp {
    color: #4dc85b;
}
.telegram {
    color: #2ea5df;
}
.snapchat {
    color: #fffc00;
}












  `
